(function () {
  const slotSelector = '[data-noirset-bundle-slot]';
  const productRootSelector = 'product-info, .template-product main';
  const appSelectors = [
    '[id*="bundle" i]',
    '[class*="bundle" i]',
    '[id*="bundler" i]',
    '[class*="bundler" i]',
    '[data-bundle]',
    '[data-bundler]',
    '[data-app*="bundle" i]',
    '[data-app*="bundler" i]',
    '[class*="nice" i]',
    '[id*="nice" i]',
    '[class*="nt-" i]',
    '[class*="nt_" i]',
    '[class*="rbr-" i]',
    '[class*="_rbr" i]',
    '[class*="_bap" i]',
    '[class*="bap_" i]',
    '[class*="groupBundle" i]',
    '[class*="bundleBuilder" i]',
    '[class*="BxgyInlineWidget" i]',
    '[class*="CmmBap" i]'
  ];
  const textPattern =
    /bundle|bundler|offre|remise|discount|mix\s*(and|&)?\s*match|achetez|obtenez|gratuit|cadeau|volume|frequently|together|additionnels/i;

  function isElement(node) {
    return node && node.nodeType === Node.ELEMENT_NODE;
  }

  function isVisible(element) {
    const rect = element.getBoundingClientRect();
    const style = window.getComputedStyle(element);
    return rect.width > 120 && rect.height > 20 && style.display !== 'none' && style.visibility !== 'hidden';
  }

  function isBadCandidate(element, slot) {
    const tagName = element.tagName;

    return (
      tagName === 'SCRIPT' ||
      tagName === 'STYLE' ||
      tagName === 'NOSCRIPT' ||
      tagName === 'TEMPLATE' ||
      element === slot ||
      element.closest(slotSelector) ||
      element.closest('header, footer, cart-drawer, .drawer, .modal, .shopify-section-header') ||
      element.classList.contains('product-form__buttons') ||
      element.closest('.product-form__buttons') ||
      element.matches('product-info, .product__info-container, .product, .page-width') ||
      element.querySelector('.product-form__buttons')
    );
  }

  function candidateScore(element) {
    const rect = element.getBoundingClientRect();
    const idClass = `${element.id || ''} ${element.className || ''}`;
    let score = rect.width * rect.height;

    if (/bundle|bundler/i.test(idClass)) score -= 500000;
    if (/nice|nt-/i.test(idClass)) score -= 150000;
    if (textPattern.test(element.innerText || '')) score -= 50000;

    return score;
  }

  function normalizeCandidate(element, root, slot) {
    let normalized =
      element.closest(
        [
          '[class*="_widget_" i]',
          '[class*="mainSection_container" i]',
          '[class*="bundleBuilderApp_container" i]',
          '[class*="pMMBundleBuilderPage_container" i]',
          '[class*="buyxgetyBundleBuilderPage_container" i]',
          '[class*="BxgyInlineWidget" i]',
          '[class*="CmmBap" i]',
          '[class*="_bap_" i]'
        ].join(',')
      ) || element;

    while (normalized.parentElement && normalized.parentElement !== root) {
      const parent = normalized.parentElement;
      const text = (parent.innerText || '').trim();
      const className = String(parent.className || '');

      if (
        isBadCandidate(parent, slot) ||
        text.length > 3000 ||
        parent.children.length > 80 ||
        parent.matches('form, product-form, product-info, .product__info-container, .product, .page-width')
      ) {
        break;
      }

      if (/bundle|bundler|fast|rbr|bap/i.test(className) || textPattern.test(text)) {
        normalized = parent;
      } else {
        break;
      }
    }

    return normalized;
  }

  function collectCandidates(root, slot) {
    const candidates = new Set();

    appSelectors.forEach((selector) => {
      root.querySelectorAll(selector).forEach((element) => candidates.add(normalizeCandidate(element, root, slot)));
    });

    root.querySelectorAll('div, section, article, form, iframe').forEach((element) => {
      const text = (element.innerText || '').trim();
      const childCount = element.children.length;

      if (text && text.length < 1800 && childCount < 35 && textPattern.test(text)) {
        candidates.add(normalizeCandidate(element, root, slot));
      }
    });

    return Array.from(candidates)
      .filter((element) => isElement(element) && !isBadCandidate(element, slot) && isVisible(element))
      .sort((a, b) => candidateScore(a) - candidateScore(b));
  }

  function placeBundle() {
    const slot = document.querySelector(slotSelector);
    if (!slot) return false;

    const root = slot.closest(productRootSelector) || document;
    const current = slot.querySelector('.noirset-bundle-widget');

    if (current && isVisible(current)) {
      slot.hidden = false;
      return true;
    }

    const widget = collectCandidates(root, slot)[0];
    if (!widget) return false;

    widget.classList.add('noirset-bundle-widget');
    slot.appendChild(widget);
    slot.hidden = false;

    return true;
  }

  function start() {
    let attempts = 0;
    const maxAttempts = 40;

    const tick = () => {
      attempts += 1;
      const placed = placeBundle();

      if (!placed && attempts < maxAttempts) {
        window.setTimeout(tick, 500);
      }
    };

    const observer = new MutationObserver(() => {
      placeBundle();
    });

    observer.observe(document.body, { childList: true, subtree: true });
    tick();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
